import React, { useState, useEffect } from "react";
import DefaultUserRound from "../assets/imgs/DefaultUserRound.png";

const UserSearchableDropdown = ({
  options = [], // expects array of user objects
  onSelect,
  defaultValue = null, // can be a user object or null
  name,
  className,
  disabled = false,
  labelKey = "name", // key used for search/display (e.g. name or email)
  placeholder = "",
}) => {
  const [inputValue, setInputValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  // Update input when default value changes
  useEffect(() => {
    if (defaultValue) {
      setInputValue(defaultValue[labelKey] || "");
    }
  }, [defaultValue, labelKey]);

  // Handle typing/filter
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setShowDropdown(true);
    setHighlightedIndex(-1);

    const filtered = options.filter((opt) =>
      (opt[labelKey] || "")
        .toLowerCase()
        .includes(value.toLowerCase())
    );

    setFilteredOptions(filtered);
  };

  const handleKeyDown = (e) => {
    const list = filteredOptions.length > 0 ? filteredOptions : options;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      if (!showDropdown) {
        setShowDropdown(true);
        setHighlightedIndex(0);
        return;
      }
      setHighlightedIndex((prev) => {
        if (prev < 0) return 0;
        return prev + 1 < list.length ? prev + 1 : 0;
      });
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      if (!showDropdown) {
        setShowDropdown(true);
        setHighlightedIndex(0);
        return;
      }
      setHighlightedIndex((prev) => {
        if (prev <= 0) return list.length - 1;
        return prev - 1;
      });
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightedIndex >= 0 && highlightedIndex < list.length) {
        handleOptionClick(list[highlightedIndex]);
      } else if (list.length > 0) {
        handleOptionClick(list[0]);
      }
    } else if (e.key === "Escape") {
      setShowDropdown(false);
    }
  };

  // Handle selection
  const handleOptionClick = (option) => {
    setInputValue(option[labelKey] || "");
    setShowDropdown(false);
    onSelect(option);
  };

  const handleBlur = () => {
    setTimeout(() => setShowDropdown(false), 150);
  };

  const displayList = filteredOptions.length > 0 ? filteredOptions : options;

  return (
    <div style={{ position: "relative"}} className={className}>
      <input
        type="text"
        name={name}
        className={className}
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onFocus={() => {
          setFilteredOptions(options);
          setShowDropdown(true);
        }}
        onBlur={handleBlur}
        placeholder={placeholder}
        style={{
          width: "100%",
          height: "37px",
          boxSizing: "border-box",
          padding: "8px 12px",
          border: "1px solid #C2E6D1",
          borderRadius: "8px",
          background: "#F4FAF5",
          fontSize:"14px",
          color:"#183930",
          marginTop:"0px"
        }}
        disabled={disabled}
      />

      {showDropdown && displayList.length > 0 && (
        <ul
          style={{
            position: "absolute",
            width:"100%",
            top: "100%",
            left: 0,
            right: 0,
            backgroundColor: "#ffffff",
            border: "1px solid #c2e6d1",
            borderRadius: "10px",
            listStyle: "none",
            margin: 0,
            padding: 0,
            maxHeight: "250px",
            overflowY: "auto",
            zIndex: 1000,
            scrollbarWidth: "none",
          }}
        >
          {displayList.map((user, idx) => (
            <li
              key={user._id || idx}
              onMouseDown={() => handleOptionClick(user)}
              style={{
                padding: "8px",
                cursor: "pointer",
                display: "flex",
                alignItems:"center",
                gap:"10px",
                borderBottom: "1px solid #f1f1f1",
                backgroundColor: highlightedIndex === idx ? "#f4faf5" : "transparent",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#f4faf5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = highlightedIndex === idx ? "#f4faf5" : "transparent")
              }
            >
              <span style={{ fontWeight: 500, fontSize: "13px", color: "#2c3e50" }}>
                <img
                  style={{
                    height: "40px",
                    width: "40px",
                    objectFit: "cover",
                    borderRadius: "50%"
                  }}    
                  src={DefaultUserRound}
                  alt="user"
                />
              </span>
              <div
                style={{
                  display:"flex",
                  flexDirection:"column"
                }}
              >

                <span style={{ fontWeight: 500, fontSize: "13px", color: "#2c3e50" }}>
                  {user.name || user.email}
                </span>
                <span style={{ fontSize: "12px", color: "#777" }}>
                  {user.email}
                </span>
              </div>
              <span style={{ fontSize: "15px", color: "#183930", marginLeft:"auto", textTransform:"capitalize" }}>
                {user.responsibilities || "Admin"}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default UserSearchableDropdown;
